/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
  var touchingCarousel = false,
    touchStartCoords;

  document.body.addEventListener('touchstart', function(e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    }
  });

  document.body.addEventListener('touchmove', function(e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };

    if (Math.abs(moveVector.x) > 7)
      e.preventDefault()

  }, {passive: false});
})();

(function() {
  var links = document.links;

    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
      }
    }
}());

//// 

/* Fix for the DooFinder search - 
* Close the menu panel when the search has been clicked
* to allow for scrolling
*/
(function($){
  $(function(){ // document ready
    $('#searchButtonNav_m').click(function() {
      // if menu open
      if(document.querySelector('.PageOverlay').classList.contains('is-visible')) {
        // close menu by clicking close btn
        $('.Drawer__Header .Drawer__Close').click();
      }
    });
    
  });
})(jQuery);



(function() {

  if($('#shopify-section-page-faq-template').length) {
      console.log('FAQv2.1');
      const queryString = window.location.search;

      // create URLParams obj
      const urlParams = new URLSearchParams(queryString);

      // if question parameter exists
      if(urlParams.has('question')) {

          // get and log param: question
          const faqQuestion = urlParams.get('question')

          // create ID indentifier
          let buttonID = '#question--cta--' + faqQuestion;

          if($(buttonID).length) {

              // scroll to question - 300 offset
              $('html, body').animate({
                  scrollTop: $(buttonID).offset().top - 300
              }, 500);

              // click expand the question
              $(buttonID).click();

          }

      }
  }

}());

// Fix for drawer focus accessibility issue
(function() {
  // Listen for drawer close events and blur focused elements
  document.addEventListener('click', function(e) {
      if (e.target.closest('[data-action="close-drawer"]')) {
          // Find the drawer that's being closed
          const drawerId = e.target.closest('[data-action="close-drawer"]').getAttribute('data-drawer-id');
          if (drawerId) {
              const drawer = document.getElementById(drawerId);
              if (drawer) {
                  // Blur any focused element inside the drawer before it gets hidden
                  const focusedElement = drawer.querySelector(':focus');
                  if (focusedElement) {
                      focusedElement.blur();
                  }
              }
          }
      }
  });
}());

// Scroll tracker for first .shopify-section descendant of #main
(function() {
  let firstSectionScrolledOut = false;
  
  function handleScroll() {
      const main = document.getElementById('main');
      if (!main) return;
      
      const firstSection = main.querySelector('.shopify-section');
      if (!firstSection) return;
      
      const rect = firstSection.getBoundingClientRect();
      const isScrolledOut = rect.bottom < 0;
      
      // Check if first section has scrolled out of view
      if (isScrolledOut && !firstSectionScrolledOut) {
          console.log('First .shopify-section has scrolled out of view');
          document.body.classList.add('first-section-scrolled-out');
          
          // Position header below announcement bar
          const announcement = document.getElementById('shopify-section-announcement');
          const header = document.getElementById('shopify-section-header');
          const headerInner = document.getElementById('section-header');
          
          if (announcement && header) {
              const announcementHeight = announcement.offsetHeight;
              header.style.top = announcementHeight + 'px';
              
              // Remove Header--transparent class
              headerInner.classList.remove('Header--transparent');
          }
          
          firstSectionScrolledOut = true;
      } else if (!isScrolledOut && firstSectionScrolledOut) {
          console.log('First .shopify-section is back in view');
          // Don't remove the class here - only when reaching the top
      }
      
      // Check if page is at the top
      if (window.pageYOffset === 0) {
          console.log('Page scrolled to top');
          document.body.classList.remove('first-section-scrolled-out');
          
          // Add Header--transparent class back (only if search is not open)
          const header = document.getElementById('shopify-section-header');
          const headerInner = document.getElementById('section-header');
          if (headerInner && headerInner.getAttribute('data-search-open') !== 'true') {
            console.log('Adding Header--transparent class custom');
            headerInner.classList.add('Header--transparent');
          }
          
          // Remove the top CSS value from header
          if (header) {
              header.style.top = '';
          }
          
          firstSectionScrolledOut = false;
      }
  }
  
  // Throttle scroll events for better performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
      if (scrollTimeout) {
          clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(handleScroll, 10);
  });
  
  // Initial check on page load
  handleScroll();
}());

// Global price discount ("Price discount percentage" theme setting).
// Liquid handles the initial render; this hook fixes the prices that theme.min.js
// re-renders on variant change (main price list and add-to-cart button price).
// Discounted products always show the reduced price plus the original admin price
// as the crossed-out compare-at price (the admin compare-at price is ignored).
// It runs on the theme's own 'variant:changed' event, which is dispatched
// synchronously right after the theme updates the DOM, so there is no flicker.
(function() {
  // Liquid sets data-price-markup-factor per product (collections/tags/expiry).
  // window.theme.priceMarkupPercentage is only a fast gate: 0 when every discount
  // is disabled or expired, so we skip attaching the listener entirely.
  var markupPercentage = (window.theme && window.theme.priceMarkupPercentage) || 0;

  if (!(markupPercentage > 0)) {
    return;
  }

  function applyMarkup(cents, factor) {
    return Math.round(cents * factor);
  }

  function readMarkupFactor(priceList) {
    if (!priceList) {
      return NaN;
    }

    var raw = priceList.getAttribute('data-price-markup-factor');
    var factor = parseFloat(raw);

    if (!isFinite(factor) || factor <= 0 || factor > 1) {
      return NaN;
    }

    return factor;
  }

  // Exact copy of the theme's Currency.formatMoney so re-rendered prices keep the same format
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var value = '';

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant,
        previousVariant = event.detail.previousVariant;

    // On initial page load the DOM prices come from Liquid and already include the markup
    if (!previousVariant || !variant) {
      return;
    }

    var element = event.target,
        moneyFormat = window.theme.moneyFormat,
        priceList = element.querySelector('.ProductMeta__PriceList');

    // Per-product factor from Liquid (include/exclude + expiry). 1 / missing = no discount.
    var markupFactor = readMarkupFactor(priceList);

    if (!(markupFactor > 0 && markupFactor < 1)) {
      return;
    }

    // The add-to-cart button is rebuilt by the theme on every variant change
    var buttonPrice = element.querySelector('.ProductForm__AddToCart [data-money-convertible]');

    if (buttonPrice) {
      buttonPrice.innerHTML = formatMoney(applyMarkup(variant.price, markupFactor), moneyFormat);
    }

    // The price list is only rebuilt by the theme when the price actually changed
    if (previousVariant.price === variant.price && previousVariant.compare_at_price === variant.compare_at_price) {
      return;
    }

    // Same markup as the theme's _updateProductPrices sale layout: the discounted
    // price plus the original variant price as the crossed-out compare-at price.
    // Keep data-price-markup-factor on the wrapper (innerHTML only replaces children).
    var html = '';

    html += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + formatMoney(applyMarkup(variant.price, markupFactor), moneyFormat) + '</span>';
    html += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>' + formatMoney(variant.price, moneyFormat) + '</span>';

    priceList.innerHTML = html;
  });
})();
